// The SAME 6-color palette `GlobalMapHeader.tsx`'s own KPI row already
// established (spec §4/§15: "Use the same entity colors and icons as Map
// and List") — kept here rather than trusting the backend's own `color`
// field on `recordsByType` (analytics.py's `_ENTITY_COLORS`) because color
// is a presentation concern the frontend already owns a single source of
// truth for; the backend field exists for API completeness/future
// non-web clients, not as this app's own rendering authority.
export const ANALYTICS_ENTITY_COLOR: Record<string, string> = {
  leads: "#1677ff",
  lead: "#1677ff",
  projects: "#16a34a",
  project: "#16a34a",
  subcontractors: "#9333ea",
  subcontractor: "#9333ea",
  appointments: "#0ea5e9",
  appointment: "#0ea5e9",
  workforce: "#f97316"
}

export const ANALYTICS_STATUS_OTHER_COLOR = "#94a3b8"

export const REGION_LABELS: Record<string, string> = {
  northeast: "Northeast",
  midwest: "Midwest",
  south: "South",
  west: "West",
  other: "Other",
  unknown: "Unknown"
}
